import PipelineDetails from "../PipelineDetails/PipelineDetails";
import {closed} from "../PipelineDetails/PipelineDetails";
import {executeQuery} from "../../requests/executeQuery";
import {getData} from "../../requests/CRUD";
import {TEAM} from "../../consts/tables";
import {formatName} from "../../utils";
import {AGENT_COMMISSION_PAID, AGENT_COMMISSION_PROCURED} from "../../consts/queries";
import {GrossType} from "../../consts/consts";
import filter from "../../filter";
import { GET_AGENT_COMMISSION_PAID, GET_AGENT_COMMISSION_PROCURED } from "../Graphql/Queries/agentCommissionBreakdown";
import { GET_TEAMMEMBER_BY_ID } from "../Graphql/Queries/TeamMemberQuery";
import { GetOldResponse, mapToOldResponse } from "../ResponseConversion/GetOldResponse";
import { GET_CONTACT_TEAM_BY_ARCIMEDES_ID, GET_CONTACT_TEAM_BY_ID } from "../Graphql/ContactsQueries/contactsQuery";
import { fetchData } from "../Service/graphQlService";
import { browserHistory } from "react-router";

const findIndex = require('lodash.findindex');
function compareDates(a,b){
    const dateA = new Date(a.CLOSE_OF_ESCROW);
    const dateB = new Date(b.CLOSE_OF_ESCROW);
    return dateA - dateB;
}
export default class AgentCommissionDetails extends PipelineDetails {
    constructor(props) {
        super(props);

        this.state = {
            tables: {
                [closed]: {
                    name: 'Closed',
                    data: [],
                    total: {},
                },
            },
            agentName: '',
            grossType: '',
            loading: false,
            query: {
                DATE: '',
                AGENT_ID: '',
                AGENT_NAME:'',
            },
        }
    }

    componentDidUpdate(prevProps,prevState){
        const { location: {pathname,state}, routeParams:{id,year} } = this.props;
        if(pathname.match(/(paid|procured)/)){
            if(prevState.query.DATE!==year && prevState.query.AGENT_ID!==id){
                this.setState({query:{DATE: year,AGENT_ID:id}})
            }

            if(state && state.paidProcuredonSubmit){
                const pathnameArray = this.props.location && this.props.location.pathname ? this.props.location.pathname.split('/') : [];
                const grossType = this.state.query.AGENT_NAME ? (this.state.query.AGENT_NAME) : (pathnameArray && pathnameArray.length ? pathnameArray[pathnameArray.length - 1] : (this.props.grossType ? this.props.grossType : this.props.params.grossType));
                browserHistory.replace({pathname: window.location.pathname, state:null})
                grossType === 'paid' ? this.fetchPaid(id, year, grossType) : this.fetch(id, year, grossType);           
            }

           
        }
    }
    
    static convertData(dataToConvert, id) {
        const data = [];
        let arcRowId;

        dataToConvert.forEach(property => {
            if (arcRowId && property.ARCIMEDES_ROW_ID === arcRowId) {
                const index = data.length - 1;
                if (property.MEMBER_ID !== Number(id)) {
                    data[index].ADDITIONAL_AGENTS = `${data[index].ADDITIONAL_AGENTS}${data[index].ADDITIONAL_AGENTS ? ', ' : ''}${formatName(property, '')}`;
                } else {
                    data[index].PERCENTAGE = property.PERCENTAGE;
                    data[index].TEAM_MEMBER_GROSS_FEE = property.TEAM_MEMBER_GROSS_FEE;
                    data[index].LISTING_GROSS_COMMISSION = property.LISTING_GROSS_COMMISSION;
                    if((property.BUYER_AGENT_1!==null && property.BUYER_AGENT_2===null && property.BUYER_AGENT_3===null)||
                    (property.BUYER_AGENT_1===null && property.BUYER_AGENT_2!==null && property.BUYER_AGENT_3===null)||
                    (property.BUYER_AGENT_1===null && property.BUYER_AGENT_2===null && property.BUYER_AGENT_3!==null)){
                        data[index].BUYING_GROSS_COMMISSION = 2*property.BUYING_GROSS_COMMISSION;
                    }else{
                        data[index].BUYING_GROSS_COMMISSION = property.BUYING_GROSS_COMMISSION;
                    }                    
                }
            } else {
                              
                const index = findIndex(dataToConvert, {ARCIMEDES_ROW_ID: property.ARCIMEDES_ROW_ID, MEMBER_ID: Number(id)});
                if (index !== -1) {
                    arcRowId = property.ARCIMEDES_ROW_ID;
                    data.push({
                        ARCIMEDES_ROW_ID: property.ARCIMEDES_ROW_ID,
                        CLOSE_OF_ESCROW: property.CLOSE_OF_ESCROW,
                        NAME: property.NAME,
                        CITY: property.CITY,
                        STATE: property.STATE,
                        SOLD_PRICE: property.SOLD_PRICE,
                        BUYER_AGENT_1: property.BUYER_AGENT_1,
                        BUYER_AGENT_2: property.BUYER_AGENT_2,
                        BUYER_AGENT_3: property.BUYER_AGENT_3,
                        PERCENTAGE: property.MEMBER_ID === Number(id) ? property.PERCENTAGE : '',
                        TEAM_MEMBER_GROSS_FEE: property.MEMBER_ID === Number(id) ? property.TEAM_MEMBER_GROSS_FEE : '',
                        LISTING_GROSS_COMMISSION: property.MEMBER_ID === Number(id) ? property.LISTING_GROSS_COMMISSION : '',
                        BUYING_GROSS_COMMISSION: property.MEMBER_ID === Number(id) ? property.BUYING_GROSS_COMMISSION : '',
                        ADDITIONAL_AGENTS: property.MEMBER_ID !== Number(id) ? formatName(property, '') : '',
                        PROCURED: property.BUYER_AGENT_1 != null && property.BUYER_AGENT_1 === Number(id) ? true
                            : property.BUYER_AGENT_2 != null && property.BUYER_AGENT_2 === Number(id) ? true
                                : property.BUYER_AGENT_3 != null && property.BUYER_AGENT_3 === Number(id) ? true
                                    : property.LISTING_AGENT_1 != null && property.LISTING_AGENT_1 === Number(id) ? true
                                        : property.LISTING_AGENT_2 != null && property.LISTING_AGENT_2 === Number(id) ? true
                                            : property.LISTING_AGENT_3 != null && property.LISTING_AGENT_3 === Number(id) ? true
                                                : false,
                        
                        BUYER_AGENT_1_PERCENT: property.BUYER_AGENT_1_PERCENT,
                        BUYER_AGENT_2_PERCENT: property.BUYER_AGENT_2_PERCENT,
                        BUYER_AGENT_3_PERCENT: property.BUYER_AGENT_3_PERCENT,
                        LISTING_AGENT_1: property.LISTING_AGENT_1,
                        LISTING_AGENT_2: property.LISTING_AGENT_2,
                        LISTING_AGENT_3: property.LISTING_AGENT_3,
                        LISTING_AGENT_1_PERCENT: property.LISTING_AGENT_1_PERCENT,
                        LISTING_AGENT_2_PERCENT: property.LISTING_AGENT_2_PERCENT,
                        LISTING_AGENT_3_PERCENT: property.LISTING_AGENT_3_PERCENT,
                        POTENTIAL_FEE: property.POTENTIAL_FEE,
                        TRANSACTION_TYPE: property.TRANSACTION_TYPE,
                        REFERRAL_FEE: property.REFERRAL_FEE,
                        LISTING_PERCENTAGE: property.LISTING_PERCENTAGE,
                        BUYING_PERCENTAGE: property.BUYING_PERCENTAGE,
                    });
                }
            }
        });

        return data;
    }

    componentDidMount() {
        const id = this.props.location && this.props.location.state && this.props.location.state.id ? this.props.location.state.id :
            (this.props.id ? this.props.id : this.props.params.id);
        const year = this.props.location && this.props.location.state && this.props.location.state.year ? this.props.location.state.year :
            (this.props.year ? this.props.year : this.props.params.year);

        const pathnameArray = this.props.location && this.props.location.pathname ? this.props.location.pathname.split('/') : [];
        const grossType = pathnameArray && pathnameArray.length ? pathnameArray[pathnameArray.length - 1] :
            (this.props.grossType ? this.props.grossType : this.props.params.grossType);
        if (id && grossType) {        
            grossType === 'paid' ? this.fetchPaid(id, year, grossType) : this.fetch(id, year, grossType);              
            return;
        }
        this.setState({loading: false});
    }
    
    fetchPaid(id, year, grossType) {  
        let teamOptions = {};
        let q = {
            AGENT_ID: id,
            YEAR: year,
            order:'CLOSE_OF_ESCROW.asc'
        }
        const options = filter(q, 'agent-commission');
        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        if (!agentName) {
            teamOptions = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
        }
        
        const token = localStorage.getItem('authToken');
        const optionsYear = parseInt(options.param.YEAR);
        const optionsAgentId = parseInt(options.param.AGENT_ID);
        Promise.all([
            // executeQuery({ queryName: AGENT_COMMISSION_PROCURED, options }), 
            // executeQuery({ queryName: AGENT_COMMISSION_PAID, options }),
            // getData({tableCode: TEAM, options: teamOptions})
            // this.client.query({ query: GET_AGENT_COMMISSION_PROCURED, variables:{year: optionsYear, agentId: optionsAgentId},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            //     this.client.query({ query: GET_AGENT_COMMISSION_PAID, variables:{options:{year: optionsYear, agent_id: optionsAgentId}},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       },
            //     } }),
            // // this.client.query({query:GET_TEAM, variables:{options:teamOptions}}),
            // this.client.query({query: GET_TEAMMEMBER_BY_ID,variables:{arcimedes_row_id: id},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       }}
            //     })


            fetchData(GET_AGENT_COMMISSION_PROCURED, {year: optionsYear, agentId: optionsAgentId}),
                    fetchData( GET_AGENT_COMMISSION_PAID, {options:{year: optionsYear, agent_id: optionsAgentId}}),
                fetchData( GET_CONTACT_TEAM_BY_ARCIMEDES_ID,{arcimedes_row_id: Number(id)})
                // fetchData( GET_CONTACT_TEAM_BY_ID,{contactid: Number(id)})
        ]).then(res => {
            const result = mapToOldResponse(res).responses;
            // if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
            //     res[1] && res[1].success && Array.isArray(res[1].data) &&
            //     res[2] && res[2].success && Array.isArray(res[2].data)) 
            if (result && result[0] && result[0].success && Array.isArray(result[0].data[0].AGENTCOMMISSIONPROCURED) &&
                result[1] && result[1].success && Array.isArray(result[1].data[0].AGENTCOMMISSIONPAID) &&
                result[2] && result[2].success && Array.isArray(result[2].data)) {
                
                let map = new Map();
                result[0].data[0].AGENTCOMMISSIONPROCURED.forEach(item =>{ 
                    map.set(item.ARCIMEDES_ROW_ID, item)
                });                

                const tables = {...this.state.tables};
                const data = grossType === GrossType.Paid ? AgentCommissionDetails.convertData(result[1].data[0].AGENTCOMMISSIONPAID, id) : result[1].data[0].AGENTCOMMISSIONPAID;
                const status = grossType ? grossType.charAt(0).toUpperCase() + grossType.slice(1) : '';
                tables[closed].name = `Closed - ${status}`;
                data.forEach((item,index )=> {
                    if (map.has(item.ARCIMEDES_ROW_ID)) {
                        let listingGrossCommission = map.get(item.ARCIMEDES_ROW_ID).LISTING_GROSS_COMMISSION;
                        let buyingGrossCommission = map.get(item.ARCIMEDES_ROW_ID).BUYING_GROSS_COMMISSION;
                        map.set(item.ARCIMEDES_ROW_ID, {...data[index], listingGrossCommission,buyingGrossCommission});
                    } else {
                        map.set(item.ARCIMEDES_ROW_ID, item);
                    }
                });
                const mergedArray =  Array.from(map.values()); 
                mergedArray.sort(compareDates);
                tables[closed] = AgentCommissionDetails.buildTable(closed, tables[closed], mergedArray, grossType,id);
                    if (result[2])
                    // agentName = formatName(result[2].data[0].GETTEAMMEMBER);
                    agentName = formatName(result[2].data[0].GETCONTACTTEAMBYARCID.CONTACT);
                this.setState({
                    agentName,
                    tables,
                    grossType
                });                
               
            }
        });
    }

    fetch(id, year, grossType) {
        let queryName = '';
        let q = {};
        switch (grossType) {
            case GrossType.Procured:
                queryName = GET_AGENT_COMMISSION_PROCURED;
                q = {
                    AGENT_ID: id,
                    YEAR: year,
                    order:'CLOSE_OF_ESCROW.asc'
                }
                break;
            case GrossType.Paid:
                queryName = GET_AGENT_COMMISSION_PAID;
                q = {
                    YEAR: year,
                    order:'CLOSE_OF_ESCROW.asc'
                }
                break;
        }
        const options = filter(q, 'agent-commission');
        
        const token = localStorage.getItem('authToken');
        const optionsYear = parseInt(options.param.YEAR);
        const optionsAgentId = parseInt(options.param.AGENT_ID);
        const requests = [
            // executeQuery({queryName, options}) 

            // this.client.query({query: queryName, variables:{year: optionsYear, agentId: optionsAgentId},
            //     fetchPolicy: "no-cache",
            //     context: {
            //       headers: {
            //         authorization: `Bearer ${token}`,
            //       }}
            //     })
               fetchData(queryName, {year: optionsYear, agentId: optionsAgentId})
        ];

        let agentName = this.props.location && this.props.location.state ? this.props.location.state.name : this.props.name;
        if (!agentName) {
            const options = {
                column: [
                    'FIRST_NAME',
                    'LAST_NAME',
                ],
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            };
            // requests.push(getData({tableCode: TEAM, options}));
            requests.push(
                // this.client.query({query: GET_TEAMMEMBER_BY_ID,variables:{arcimedes_row_id: id},
                // fetchPolicy: "no-cache",
                // context: {
                //   headers: {
                //     authorization: `Bearer ${token}`,
                //   }}
                // }))
                // fetchData( GET_CONTACT_TEAM_BY_ID,{contactid: Number(id)})
                fetchData( GET_CONTACT_TEAM_BY_ARCIMEDES_ID,{arcimedes_row_id: Number(id)})
            )
        }

        Promise.all(requests).then(res => {
            const resul = mapToOldResponse(res).responses;
            const resultZero = resul[0].data[0].AGENTCOMMISSIONPROCURED ? resul[0].data[0].AGENTCOMMISSIONPROCURED : resul[0].data[0].AGENTCOMMISSIONPAID
            
            
            if (resul && resul[0] && resul[0].success && Array.isArray(resultZero) &&
                (!resul[1] || (resul[1] && resul[1].success && Array.isArray(resul[1].data)))) {
                const tables = {...this.state.tables};
                const data = grossType === GrossType.Paid ? AgentCommissionDetails.convertData(resultZero, id) : resultZero;
                const status = grossType ? grossType.charAt(0).toUpperCase() + grossType.slice(1) : '';
                tables[closed].name = `Closed - ${status}`;
                tables[closed] = AgentCommissionDetails.buildTable(closed, tables[closed], data, grossType,id);
                if (resul[1])
                    // agentName = formatName(resul[1].data[0].GETTEAMMEMBER);
                    // agentName = formatName(resul[1].data[0].GETCONTACTBYCONTACTID.CONTACT);
                    agentName = formatName(resul[1].data[0].GETCONTACTTEAMBYARCID.CONTACT);
                this.setState({
                    agentName,
                    tables,
                    grossType
                });
            }
            this.setState({loading: false});
        });
    }
}